<template>
    <div class="member-list">

        <section class="list-input">
            <el-select class="item" v-model="selectValue" placeholder="全部身份">
                <el-option
                    v-for="item in identity"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker class="item" v-model="param.date" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="加入开始日期" end-placeholder="加入结束日期"
                            :picker-options="pickerOptions2">
            </el-date-picker>
            <el-input  class="item" style="width: 240px" v-model="name" placeholder="输入昵称"></el-input>
            <el-button class="item" type="primary" @click="search()" plain>搜索</el-button>
        </section>
        <!-- end 搜索栏 -->



        <section>
            <el-table :data="tableData">

                <el-table-column label="序号" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1 ) + ((apiData.page - 1) * 10) }}
                    </template>
                </el-table-column>

                <el-table-column label="昵称" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="table-title">
                            <template v-if="scope.row.headlogourl">
                                <img class="headerimg" :src="scope.row.headlogourl" alt="img">
                            </template>
                            <template v-else>
                                <img class="headerimg" src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                            </template>

                            <p>{{scope.row.name}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="身份" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.roletype == 1">星主</template>
                        <template v-if="scope.row.roletype == 2">管理员</template>
                        <template v-if="scope.row.roletype == 99">普通成员</template>
                    </template>
                </el-table-column>

                <el-table-column prop="datetime" label="加入时间" align="center" width="180px"></el-table-column>
                <el-table-column prop="mobileno" label="手机号码" align="center" width="110px"></el-table-column>
                <el-table-column prop="notescount" label="公告数" align="center"></el-table-column>
                <el-table-column prop="filecount" label="资料数" align="center"></el-table-column>
                <el-table-column prop="subjectcount" label="主题数" align="center"></el-table-column>
                <el-table-column label="操作" align="right" width="200">

                    <template slot-scope="scope">
                        <div class="table-position" >

                            <template v-if="scope.row.roletype == 1"></template>

                            <template v-if="message.status !== 100">

                                <template v-if="scope.row.roletype == 2 || scope.row.roletype == 99">

                                    <template v-if="scope.row.roletype == 99">
                                        <el-button @click="listStatusPosition(scope.row.innerid, 2)">设为管理员</el-button>
                                    </template>
                                    <template v-if="scope.row.roletype == 2">
                                        <el-button @click="listStatusPosition(scope.row.innerid, 99)">解除管理员</el-button>
                                    </template>

                                    <span>|</span>
                                    <el-button @click="listStatusPosition(scope.row.innerid, 3)">移除该成员</el-button>

                                </template>

                            </template>

                        </div>
                    </template>


                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <section>
            <el-pagination background layout="prev,pager,next"  @current-change="fPage()" :total="rowCount" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->

    </div>
</template>
<!--MmberList-->
<script>
import {findStarMember, uploadMeberRole, getContentMap, deleteMeber} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {getCookie} from '@/common/js/tools' // 引入 tools 库
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery' // 引入 jquery 组件
export default {
    name: 'PlaneNotes',
    props: ['message'],  // 接收父类传参 星球详细数据
    data() {
        return {
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            loading: false,
            commentinfo: [], //评论
            innerid: this.$route.query.innerid, // 星球编号
            tableData: [], // 笔记列表数据
            currentPage: 1, // 当前页面
            rowCount: 0, // 数据条数
            page: 1, // 页数
            apiData: {page:1}, // 查询/分页 api 数据
            selectValue: '',
            name: '',
            imgDialog: false,
            param: {
                date: ''
            },
            identity: [
                {
                    value: '',
                    label: '全部身份'
                },
                {
                    value: 1,
                    label: '星主'
                },
                {
                    value: 2,
                    label: '管理员'
                },
                {
                    value: 99,
                    label: '普通成员'
                }
            ],
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        // 读取地址链接  获取星球innerid
        let apiData = this.apiData = {
            LoginToken: this.token,
            starinnerid: this.innerid,
            page: 1,
            pageSize: 10
        }
        this.findStarMemberApi(apiData)
    },
    methods: {
        findStarMemberApi(data) {
            // 主题列表查询、分页通用接口调用
            findStarMember({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log(data)
                }
            })
        },
        search() {
            // 搜索
            let apiData = this.apiData = {
                LoginToken: this.token,
                starinnerid: this.innerid,
                begintime: this.param.date[0] === undefined ? '' : this.param.date[0],
                endtime: this.param.date[1] === undefined ? '' : this.param.date[1],
                name: this.name,
                roletype: this.selectValue,
                page: 1,
                pageSize: 10
            }
            this.setLoading(true)
            this.findStarMemberApi(apiData)
        },
        listStatusPosition(innerid, roletype) {
            // 管理员操作
            let txt // 文案
            switch (roletype) {
                case 2:
                    txt = '您确定设为管理员吗？'
                    break
                case 99:
                    txt = '您确定解除管理员吗？'
                    break
                case 3:
                    txt = '您确定移除该成员吗？'
                    break
            }

            this.$confirm(txt, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.setLoading(true)
                let data = {
                    LoginToken: this.token,
                    roletype: roletype,
                    starinnerid: this.innerid,
                    innerid: innerid
                }

                if (roletype === 3) {
                    // 删除成员
                    deleteMeber({
                        data: data,
                        success: data => {
                            this.setLoading(false)
                            this.$message.success("操作成功")
                            this.findStarMemberApi(this.apiData)
                        },
                        error: data => {
                            this.setLoading(false)
                            if(data.code === 301) {
                                this.$message.error("暂无权限进行此操作")
                            }
                            console.log(data)
                        }
                    })
                } else {
                    // 修改管理员身份接口连接
                    uploadMeberRole({
                        data: data,
                        success: data => {
                            console.log(data)
                            this.setLoading(false)
                            this.$message.success("操作成功")
                            // 如果是删除则调用新的接口  如果是修改状态则读取缓存文件调整
                            if (roletype === 100) {
                                this.findStarMemberApi(this.apiData)
                            } else {
                                for (let i = 0; i < this.tableData.length; i++) {
                                    if (this.tableData[i].innerid === innerid) {
                                        this.tableData[i].roletype = roletype
                                    }
                                }
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            console.log(data)
                            if(data.code === 301) {
                                this.$message.error("暂无权限进行此操作")
                            }
                        }
                    })
                }

            }).catch(() => {})
        },
        fPage() {
            // 分页处理
            this.setLoading(true)
            let clickPage = $('.dynamic-list .el-pagination .active').html()
            this.apiData.page = parseInt(clickPage)
            this.findStarMemberApi(this.apiData)
        },
        ...mapActions (
            ['setLoading']
        )
    }
}
</script>

<style lang="scss">
    .member-list {

        .el-date-editor {
        .el-range-separator {
            line-height: 27px
        }
        }
        .headerimg {
            border-radius: 50%;
        }
        .el-table {
            margin-top: 20px;

            min-height: 490px;
            .el-table__empty-block {
                width: 100% !important;
                background-position: center;
                background-size: 40%;
                height: 420px;
            }
        }
    }
</style>
